// src/components/Footer.js

import React, { useContext } from 'react';
import FooterDefault from './FooterDefault';
import FooterPro from './FooterPro';
import { AuthContext } from '../context/AuthContext';

export default function Footer(props) {
  const { user } = useContext(AuthContext);
  return user?.is_professional
    ? <FooterPro {...props} />
    : <FooterDefault {...props} />;
}
